import {
    POST_DELETED_BY_ADMIN,
    POST_DELETED_BY_AUTHOR,
    POST_DELETED_BY_MODERATOR,
} from "@/mk/autogenerated/translation";

export enum DeletedByRole {
    DeletedByAuthor = 0,
    DeletedByModerator = 1,
    DeletedByAdmin = 2,
}

export function postDeletedByToText(deletedByRole: DeletedByRole): string {
    switch (deletedByRole) {
        case DeletedByRole.DeletedByAdmin:
            return POST_DELETED_BY_ADMIN;
        case DeletedByRole.DeletedByModerator:
            return POST_DELETED_BY_MODERATOR;
        case DeletedByRole.DeletedByAuthor:
            return POST_DELETED_BY_AUTHOR;
    }
}
